import { 発注入力方法区分型 } from '@/type/purchaseorder/types';
import {Validator} from '@/type/validation/result';
import { 必須入力, 日付書式, 時刻書式 } from '@/type/validation/validator';

export interface 発注書出力条件型 {
    発注伝票番号リスト: number[] | null;
}

export interface 発注書検索条件型 {
    確定送信者コード: string | null;
    卸コード: string | null;
    発注日開始日付: Date | null;
    発注日開始時刻: string | null;
    発注日終了日付: Date | null;
    発注日終了時刻: string | null;
}

export interface 発注書検索結果型 {
    発注書検索結果リスト: 発注書検索結果レコード型[];
    アラートメッセージ: string;
}

export interface 発注書検索結果レコード型 {
    選択: boolean;
    発注伝票番号: number;
    発注日: Date;
    発注確定時刻: Date;
    納品指定日: Date | null;
    卸コード: string;
    卸名: string;
    確定送信者コード: string;
}

export interface 発注確認書出力条件型 {
    利用者コード: string | null;
    卸コード: string | null;
    発注入力方法区分: 発注入力方法区分型 | null;
    発注日開始日付: Date | null;
    発注日終了日付: Date | null;
    並び順区分: 発注確認書並び順区分型 | null;
}

export enum 発注確認書並び順区分型 {
    指定なし = '指定なし',
    商品名カナ = '商品名カナ',
    メーカー名 = 'メーカー名',
    卸 = '卸',
}

export const 発注書出力条件バリデータ一覧: Validator[] = [
    {
        name: '発注日開始日付',
        constraints: [
            {method: 必須入力, message: '発注日開始日付は入力が必要です'},
            {method: 日付書式, message: '発注日開始日付の書式が不正です'},
        ],
    },
    {
        name: '発注日開始時刻',
        constraints: [
          {method: 時刻書式, message: '発注日開始時刻の書式が不正です'},
        ],
    },
    {
        name: '発注日終了日付',
        constraints: [
            {method: 必須入力, message: '発注日終了日付は入力が必要です'},
            {method: 日付書式, message: '発注日終了日付の書式が不正です'},
        ],
    },
    {
        name: '発注日終了時刻',
        constraints: [
          {method: 時刻書式, message: '発注日終了時刻の書式が不正です'},
        ],
    },
];

export const 発注確認書出力条件バリデータ一覧: Validator[] = [
  {
    name: '発注日開始日付',
    constraints: [
          {method: 必須入力, message: '発注日開始日付は入力が必要です'},
          {method: 日付書式, message: '発注日開始日付の書式が不正です'},
      ],
  },
  {
    name: '発注日終了日付',
    constraints: [
          {method: 日付書式, message: '発注日終了日付の書式が不正です'},
      ],
  },
];
